// Visit https://api.openweathermap.org & then signup to get our API keys for free
module.exports = {
  key: "9e2005cdf3605e22da666bc645151aa8",
  base: "https://api.openweathermap.org/data/2.5/",
};
